<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  prefix?: string
  name: string
  color?: string
  size?: string
}

const props = withDefaults(defineProps<Props>(), {
  prefix: 'icon',
  color: 'black',
  size: '20px'
})
const symbolId = computed(() => `#${props.prefix}-${props.name}`);

</script>

<template>
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    :height="props.size"
    :width="props.size"
    :class="`text-${props.color}`"
  >
    <use :href="symbolId" />
  </svg>
</template>
